export const copyLinkSuccess = {
  title: 'Link copied to clipboard',
};
